import { SystemCode, SystemCodeFromJSON } from '@/api'
import {
  SystemCodeWithKey,
  SystemCodeWithKeyFromJSON
} from '@/api/models/system-code/SystemCodeWithKey'
import * as runtime from '../runtime'

export interface GetSystemCodeRequest {
  codeKey: string
  codeKeys: string[]
  code: string
}

export interface UpdateSystemCodesRequest {
  codeKey: string
  codeKeyRevision: number
  codes: {
    code: string
    name: string
    shortName: string
    option1: string
    option2: string
    option3: string
    option4: string
    option5: string
    option6: string
  }[]
}

export class SystemCodeApi extends runtime.BaseAPI {
  /**
   * システムコードの一覧を取得する
   * システムコード取得
   */
  async getSystemCodes(request: GetSystemCodeRequest): Promise<SystemCode[]> {
    const queryParameters: runtime.HTTPQuery = {}

    if (request.codeKey !== '') {
      queryParameters.code_key = request.codeKey
    }

    if (request.codeKeys.length !== 0) {
      queryParameters.code_keys = request.codeKeys
    }

    if (request.code !== '') {
      queryParameters.code = request.code
    }

    const response = await this.requestGet(`/system-codes`, queryParameters)

    return new runtime.JSONApiResponse(response, jsonValue =>
      jsonValue.map(SystemCodeFromJSON)
    ).value()
  }

  /**
   * 入力条件により、システムコードキーを取得する
   * システムコードキー取得
   */
  async getSystemCodeWithKey(codeKey: string): Promise<SystemCodeWithKey> {
    const queryParameters: runtime.HTTPQuery = { code_key: codeKey }
    const response = await this.requestGet(
      `/system-codes/with-key`,
      queryParameters
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      SystemCodeWithKeyFromJSON(jsonValue)
    ).value()
  }

  /**
   * システムコードを更新する
   * システムコード更新
   */
  async updateSystemCodes(
    request: UpdateSystemCodesRequest
  ): Promise<runtime.VoidApiResponse> {
    const bodyParameters: runtime.HTTPBody = {
      code_key: request.codeKey,
      code_key_revision: request.codeKeyRevision,
      codes: []
    }

    request.codes.forEach((code, index) => {
      bodyParameters.codes[index] = {
        code: code.code,
        name: code.name,
        short_name: code.shortName,
        option1: code.option1,
        option2: code.option2,
        option3: code.option3,
        option4: code.option4,
        option5: code.option5,
        option6: code.option6
      }
    })

    const response = await this.requestPut('/system-codes', bodyParameters)
    return new runtime.VoidApiResponse(response)
  }
}
